import React, { createContext, useContext } from 'react';
import type { UserGoal } from '@shared/types';

interface GoalCelebrationContextValue {
  replay: (goal: UserGoal) => void;
}

const GoalCelebrationContext = createContext<GoalCelebrationContextValue>({
  replay: () => {},
});

export const GoalCelebrationProvider: React.FC<{
  replay: (goal: UserGoal) => void;
  children: React.ReactNode;
}> = ({ replay, children }) => (
  <GoalCelebrationContext.Provider value={{ replay }}>
    {children}
  </GoalCelebrationContext.Provider>
);

export const useGoalCelebration = () => useContext(GoalCelebrationContext);
